
// src/firebase.paths.js

/**
 * Este módulo centraliza todos os caminhos de coleções do Firestore
 * para manter o App.js limpo e facilitar a manutenção/auditoria dos caminhos.
 * @param {string} appId - O ID global da aplicação (__app_id).
 * @returns {{
 * users: string, 
 * suggestions: string, 
 * config: string, 
 * transactions: string,
 * news: string 
 * }} - Um objeto com os caminhos completos das coleções.
 */
export const getPaths = (appId) => {
    const publicDataPath = `artifacts/${appId}/public/data`;

    return {
        // Coleção de perfis de usuário/leaderboard
        users: `${publicDataPath}/users`,
        
        // Coleção de sugestões
        suggestions: `${publicDataPath}/suggestions`, // <--- A vírgula foi adicionada aqui
        
        // Coleção de configuração (usada para estoque da loja: config/shopStock)
        config: `${publicDataPath}/config`,
        
        // Coleção de logs de transações/auditoria
        transactions: `${publicDataPath}/transactions`,

        // Coleção de Notícias (ADICIONADA)
        news: `${publicDataPath}/news`, 
    };
};